<template>
  <div class="schedule-reception">
    <section v-for="column in columns" :key="column.id" class="schedule-reception__col">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="fs-6 fw-bolder mb-0">{{ column.title }}</h3>
        <span class="sw-count">{{ column.items.length }}</span>
      </div>
      <p class="text-muted fs-8">{{ column.hint }}</p>
      <ScheduleAppointmentCard
        v-for="item in column.items"
        :key="item.id_sched"
        class="mb-2"
        :schedule="item"
        variant="reception"
        show-time
        @click="$emit('open-schedule', $event)"
        @takePicture="$emit('take-picture', $event)"
        @openRecurrence="$emit('open-recurrence', $event)"
        @onArriveSchedule="$emit('arrive', $event)"
        @onFinishSchedule="$emit('finish', $event)"
        @onReopenSchedule="$emit('reopen', $event)"
        @onStartAttendance="$emit('start', $event)"
      />
      <p v-if="!column.items.length" class="text-muted fs-8 mb-0">Ninguém neste passo.</p>
    </section>
  </div>
</template>

<script>
import ScheduleAppointmentCard from './ScheduleAppointmentCard.vue';
import { isPatientSchedule, sortByArrivalThenTime } from '../../../helpers/scheduleDay';

export default {
  name: 'ScheduleReceptionBoard',
  components: { ScheduleAppointmentCard },
  props: {
    schedules: { type: Array, default: () => [] },
  },
  emits: ['open-schedule', 'take-picture', 'open-recurrence', 'arrive', 'finish', 'reopen', 'start'],
  computed: {
    patients() {
      return this.schedules.filter(isPatientSchedule);
    },
    columns() {
      return [
        {
          id: 'next',
          title: 'Próximos',
          hint: 'Ainda não chegaram.',
          items: this.patients.filter((item) => ['AG', 'CO'].includes(item.sched_status) && !item.sched_arrive),
        },
        {
          id: 'wait',
          title: 'Na espera',
          hint: 'Chegou. Chamar ou atender.',
          items: sortByArrivalThenTime(
            this.patients.filter((item) => item.sched_arrive && !item.sched_start && item.sched_status !== 'FI'),
          ),
        },
        {
          id: 'care',
          title: 'Em atendimento',
          hint: 'Já iniciou. Finalizar daqui.',
          items: this.patients.filter((item) => item.sched_start && item.sched_status !== 'FI'),
        },
        {
          id: 'done',
          title: 'Finalizados',
          hint: 'Histórico do dia.',
          items: this.patients.filter((item) => item.sched_status === 'FI'),
        },
      ];
    },
  },
};
</script>

<style scoped>
.schedule-reception {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(4, minmax(280px, 1fr));
  gap: 1rem;
  align-items: start;
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 0.4rem;
  scrollbar-width: thin;
  scrollbar-color: #d8dbe3 transparent;
}
.schedule-reception__col {
  min-width: 280px;
  padding: 0.75rem;
  background: #f9f9fb;
  border-radius: 0.65rem;
}
.schedule-reception::-webkit-scrollbar {
  height: 0.45rem;
}
.schedule-reception::-webkit-scrollbar-thumb {
  background: #d8dbe3;
  border-radius: 999px;
}
</style>
